import React, { useCallback } from 'react';
import {
  AccessLevelInfoRequestForm,
  AccessLevelInfoRequestFormTypes,
} from '../../common/forms/AccessLevelInfoRequestForm';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import { ButtonAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { ModalDialogModifier } from '../../../../components/organisms/ModalDialog/ModalDialog';

type CurrentAccessLevelCreateFormProps = {
  createRequestForm: AccessLevelInfoRequestFormTypes;
};

export function CurrentAccessLevelCreateForm({ createRequestForm }: CurrentAccessLevelCreateFormProps) {
  const { t } = useSonTranslation('AccessLevel');

  const [showModal, setShowModal] = React.useState(false);
  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <div className="access-level__current-access-level-form">
      <ButtonAction type="button" onClick={() => setShowModal(true)}>
        {t('buttons.request')}
      </ButtonAction>
      {showModal && (
        <ModalDialog
          closeModal={closeModal}
          headline={t('form.headline.create')}
          modifier={ModalDialogModifier.WITH_NAVIGATION}
        >
          <AccessLevelInfoRequestForm form={createRequestForm} />
        </ModalDialog>
      )}
    </div>
  );
}
